import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import { compose, pick, merge } from 'ramda';
const ItemTypes = {
  CARD: 'card',
};

const cardSource = {
  beginDrag(props) {
    return pick(['index'], props);
  },
  endDrag(props, monitor) {
    const dragIndex = monitor.getItem().index;
    props.dragEnds(dragIndex);
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    // if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
    //   return;
    // }
    //
    // // Dragging upwards
    // if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
    //   return;
    // }

    // Time to actually perform the action
    props.moveCard(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const dropTargetFn = DropTarget(ItemTypes.CARD, cardTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}));
const dragSourceFn = DragSource(ItemTypes.CARD, cardSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}));
class DraggaleCard extends Component {
  render() {
    const { children, isDragging, connectDragSource, connectDropTarget, isDragSource, isDropTarget, style, className } = this.props;
    const opacity = isDragging ? 0.2 : 1;
    const newStyle = merge((isDragging ? { border: '1px dashed gray', backgroundColor: 'white' } : { cursor: isDragSource ? 'move' : 'cursor' }), style);
    const content = (
      <div style={{ ...newStyle, opacity }} className={className}>
        {children}
      </div>
    );
    if (isDragSource && isDropTarget) return connectDragSource(connectDropTarget(content));
    if (isDropTarget) return connectDropTarget(content);
    if (isDragSource) return connectDragSource(content);
    return content;
  }
}

DraggaleCard.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  moveCard: PropTypes.func.isRequired,
  isDragSource: PropTypes.bool.isRequired,
  isDropTarget: PropTypes.bool.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default compose(dropTargetFn, dragSourceFn)(DraggaleCard);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/sortable-list-with-react-dnd/draggable-card.jsx